// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__beDOE","secondary":"Button_secondary__cADu4","primary":"Button_primary__Dd21w"};